module.exports = __webpack_public_path__ + "img/Front_Remote_Radio.jpg";